import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  filterBy: null,
  sortBy: 'popular',
  orderBy: null,
  previousPage: 1,
  nextPage: 1
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};